/* Informational only: this never selects a selling plan or changes a cart. */
(() => {
  if (customElements.get('union-coffee-planner')) return;
  customElements.define('union-coffee-planner', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      const form = this.querySelector('form');
      if (!form) return;
      this.initialized = true;
      const update = () => {
        const bag = Number(form.elements.bag.value);
        const bags = Number(form.elements.bags.value);
        const daily = Number(form.elements.daily.value);
        const result = this.querySelector('[data-planner-result]');
        if (!form.checkValidity() || !Number.isFinite(bag * bags / daily) || daily <= 0) {
          result.textContent = 'Enter a valid bag quantity and daily coffee amount.';
          return;
        }
        const days = bag * bags / daily;
        result.textContent = days < 1 ? 'Less than one day of coffee.' : `About ${days.toFixed(1)} days of coffee.`;
      };
      form.addEventListener('submit', event => { event.preventDefault(); update(); });
      form.addEventListener('change', update);
      form.hidden = false;
      this.querySelector('[data-planner-fallback]').hidden = true;
      update();
    }
  });
})();
